import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectDefaultValueLabel: {
		id: 'project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.project-picker.project-default-value-label',
		defaultMessage: 'Default project',
		description: 'Label above picker for default value for project picker custom field.',
	},
	projectDefaultValueDisabledTooltip: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.project-picker.project-default-value-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default project',
		description:
			'Tooltip shown when the default project picker field is disabled and cannot be edited',
	},
});
